/* eslint-disable react/display-name */
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from 'react';

const CustomHandoutFilter = forwardRef((props, ref) => {
  const { defaultOption = 'All', filterChangedCallback, values } = props;
  const [filterState, setFilterState] = useState(defaultOption);

  useImperativeHandle(ref, () => ({
    isFilterActive: () => filterState,
    doesFilterPass: (params) => {
      if (filterState === 'Uploaded') {
        return (
          params.data.handoutItemKey !== undefined &&
          params.data.handoutItemKey !== null &&
          params.data.handoutItemKey !== ''
        );
      } else if (filterState === 'Not Uploaded') {
        return (
          params.data.handoutItemKey === undefined ||
          params.data.handoutItemKey === null ||
          params.data.handoutItemKey === ''
        );
      } else {
        return true;
      }
    },
    getModel: () => (filterState === '' ? undefined : { state: filterState }),
    setModel: (model) => setFilterState(model?.state || ''),
    getModelAsString: () => filterState,
    onNewRowsLoaded: () => console.log('new rows were loaded'),
    onAnyFilterChanged: () => console.log('another filter was changed'),
    afterGuiAttached: () => console.log('focus something???'),
  }));

  useEffect(
    () => filterChangedCallback(),
    [filterState, filterChangedCallback]
  );

  const handleFilterChange = (value) => setFilterState(value);

  return (
    <div className='overflow-y-auto max-h-60'>
      {values?.length > 0 ? (
        values.map((value) => (
          <div
            key={value}
            className={`filter-entry my-1 px-2 font-medium ${
              value === filterState ? 'text-blue-c3' : ''
            }`}
          >
            <label className='flex items-center gap-2'>
              <input
                type='radio'
                onChange={() => handleFilterChange(value)}
                checked={filterState === value}
              />
              {value}
            </label>
          </div>
        ))
      ) : (
        <p className='px-2 font-medium'>No option available</p>
      )}
    </div>
  );
});

export default CustomHandoutFilter;
